import * as React from 'react';
export const lakemichiganSvg = React.forwardRef(function lakemichiganSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0067A6',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.082 9.455s-2.24 2.466-3.108 3.78c-.017.024-2.72-3.216-2.72-3.216l.067.129 2.529 4.666c1.463-2.41 2.893-3.796 2.893-3.796C23.76 14.218 23.959 28 23.959 28 25.364 13.46 19.09 9.455 19.09 9.455',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.49 4.008s-6.937 8.695-4.644 19.847c0 0 2.369-.556 5.787.557 3.315 1.09 4.474 1.004 6.349.533 0 0-1.568 1.074-5.582.417-3.819-.626-5.821-.634-7.304.456 0 0-5.25-8.633 5.386-21.818',
      fill: '#fff',
    }),
  );
});
lakemichiganSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lakemichigan = {
  category: 'brand',
  colorable: false,
  name: 'lakemichigan',
  svg: lakemichiganSvg,
};
